<template lang="pug">
  h1.logo
    a(:href="config.url")
      img(:src="config.logo", :alt="config.title")

</template>

<script>
  import { mapState } from 'vuex'

  export default  {
    name: 'logo',
    computed: mapState([
      'config'
    ])
  }

</script>

<style scoped lang="scss">
  .logo {

  }
</style>
